module.exports = __webpack_public_path__ + "img/oxfam.9351647.png";